import { useState } from 'react';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_INFORMATION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import styles from './InformationModal.module.scss';

const InformationModal = () => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const handleOpen = ({ title: titlePayload, body: bodyPayload }) => {
    setTitle(titlePayload);
    setBody(bodyPayload);
  };

  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_INFORMATION_MODAL,
    onOpen: handleOpen
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      className={styles['information-modal']}
    >
      <ModalHeader
        className={styles['information-modal__header']}
        onRequestClose={handleModalClose}
        label={title}
      />
      <ModalBody className={styles['information-modal__body']}>
        {body}
      </ModalBody>
    </Modal>
  ) : null;
};

export default InformationModal;
